import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Download } from 'lucide-react';
import { INDUSTRIES_SERVED } from '../data/industriesData';
import IndustryCard from '../components/IndustryCard';
import { BROCHURE_PDF } from '../data/siteContent';

const Industries = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="relative overflow-hidden bg-brand-950 py-20">
        <div className="absolute inset-0 industrial-grid opacity-20" />
        <div className="relative z-10 mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8">
          <h1 className="mb-4 font-heading text-4xl font-extrabold text-white md:text-5xl">Industries</h1>
          <p className="mx-auto max-w-3xl text-neutral-300">
            Pharmaceuticals, nutraceuticals, laboratories, biotech, hospitals, food &amp; beverage, automotive,
            engineering, marine, and warehousing — sector-specific SV Bond systems with trained on-site application.
          </p>
        </div>
      </section>

      <section className="relative overflow-hidden bg-neutral-50 py-16 md:py-20">
        <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-brand-50 to-transparent opacity-50" />
        <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="mx-auto mb-12 max-w-3xl text-center">
            <span className="text-sm font-semibold uppercase tracking-wide text-brand-900">Trusted Across Sectors</span>
            <h2 className="mt-2 font-heading text-3xl font-bold text-neutral-900 md:text-4xl">Industries We Serve</h2>
            <p className="mt-4 text-lg text-neutral-600">
              From pharmaceutical cleanrooms to warehouses and cold storage, SV Bond delivers specialised flooring for
              every sector listed in our brochure.
            </p>
          </div>

          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {INDUSTRIES_SERVED.map((industry) => (
              <IndustryCard key={industry.id} industry={industry} />
            ))}
          </div>

          <div className="mt-16 text-center">
            <div className="inline-flex flex-col items-center gap-4 rounded-large border border-neutral-200 bg-white p-8 shadow-custom sm:flex-row">
              <div className="text-left sm:text-center">
                <h3 className="mb-2 font-heading text-xl font-bold text-neutral-900">Don&apos;t see your industry?</h3>
                <p className="text-sm text-neutral-600">
                  Share your area, substrate, and use (traffic, chemicals, temperature) for a site-specific
                  recommendation.
                </p>
              </div>
              <Link
                to="/contact"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-small border border-transparent bg-brand-900 px-6 py-3 text-sm font-medium text-white shadow-custom transition-all hover:bg-brand-800"
              >
                Discuss your project
                <ArrowRight className="ml-2 h-4 w-4" />
              </Link>
              <a
                href={BROCHURE_PDF}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center whitespace-nowrap rounded-small border-2 border-brand-900 px-6 py-3 text-sm font-medium text-brand-900 transition-all hover:bg-brand-50"
              >
                <Download className="mr-2 h-4 w-4" />
                Brochure (PDF)
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Industries;
